import { render, staticRenderFns } from "./ClinicAppointmentSourceReport.vue?vue&type=template&id=c82159c8&scoped=true"
import script from "./ClinicAppointmentSourceReport.vue?vue&type=script&lang=js"
export * from "./ClinicAppointmentSourceReport.vue?vue&type=script&lang=js"
import style0 from "./ClinicAppointmentSourceReport.vue?vue&type=style&index=0&id=c82159c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82159c8",
  null
  
)

export default component.exports